module.exports = __webpack_public_path__ + "img/icon_lcks.7eadd7fa.png";